import { GameFormula } from "../models/game.model";

/**
 * Determines whether more partants (selections) can be selected based on the game formula and constraints.
 *
 * @param nSelections - The current number of selected partants.
 * @param nGameBaseNo - The base number of selections allowed for the game.
 * @param nPartantPool - The total number of partants available in the pool.
 * @param gameFormula - The formula of the game, which determines the selection rules. 
 *                      Possible values are:
 *                      - 'SI': Single Individual game formula.
 *                      - 'CE': Collective Ensemble game formula.
 * @returns `true` if more partants can be selected based on the game formula and constraints; otherwise, `false`.
 */
export function canSelectMorePartants(nSelections: number, nGameBaseNo: number, nPartantPool:number, gameFormula: GameFormula): boolean {
    switch (gameFormula) {
        case 'SI':
            return nSelections < nGameBaseNo;
        case 'CE':
            return nSelections < nPartantPool;
        case 'CP':
            return (nSelections < (nGameBaseNo - 1));
        case 'CT':
            return (nSelections < (nGameBaseNo - 1));
            // return (nSelections < (nPartantPool - nGameBaseNo)) && (nSelections < nGameBaseNo);
        default:
            return false;
    }
  }

/**
 * Determines whether more associates can be selected based on the given parameters.
 *
 * @param nSelections - The current number of selections made.
 * @param nAssocies - The current number of associates selected.
 * @param nGameBaseNo - The number of base game selections.
 * @param nPartantPool - The total number of participants in the pool.
 * @param gameFormula - The formula of the game, which dictates the selection rules.
 * @returns A boolean indicating whether more associates can be selected.
 *
 * - For the 'SI' game formula, no additional associates can be selected.
 * - For the 'CE' game formula, additional associates can be selected if:
 *   - The number of associates is less than the difference between the participant pool and the base game number.
 *   - The total selections are less than the participant pool.
 * - For other game formulas, no additional associates can be selected.
 */
export function canSelectMoreAssociates(nSelections: number, nAssocies: number, nGameBaseNo: number, nPartantPool:number, gameFormula: GameFormula): boolean {
    switch (gameFormula) {
        case 'SI':
        case 'CE':
            return false;
        // case 'CE':
        //     return (nAssocies < (nPartantPool - nGameBaseNo)) && (nSelections < nPartantPool);

        case 'CP':
            return (nAssocies < (nPartantPool - nSelections));
        case 'CT':
            return (nAssocies < (nPartantPool - nGameBaseNo)) && (nSelections >= nGameBaseNo);
        default:
            return false;
    }
  }